import { type AxiosError } from 'axios'
import { type MutationOptions, useMutation } from 'react-query'

import agent from 'agent'
import useAuth from 'hooks/use-auth'
import { integrationClientsMutationKeys } from 'queries/integration-clients/query-keys'
import { getEndpointWithParams } from 'queries/queries-utils'
import { type MultiValueTags } from 'types/tags'

type MatchingTagsRequestBody = MultiValueTags | undefined
type MatchesResponse = {
  matchingAgents: string[]
}

function checkMatchingTags([endpoint, params]: ReturnType<
  typeof integrationClientsMutationKeys.postIntegrationClientsMatchesTags
>) {
  return async (body: MatchingTagsRequestBody = {}) => {
    const endpointWithParams = getEndpointWithParams(endpoint, params)

    const response = await agent.post<MatchesResponse>(endpointWithParams, body)
    return response.data
  }
}

export const usePostIntegrationClientsMatchesTags = (
  options?: Omit<
    MutationOptions<MatchesResponse, AxiosError, MatchingTagsRequestBody>,
    'mutationKey' | 'mutationFn'
  >
) => {
  const { currentTeamId: teamId } = useAuth()

  const mutationKey =
    integrationClientsMutationKeys.postIntegrationClientsMatchesTags({ teamId })

  return useMutation({
    ...options,
    mutationKey,
    mutationFn: checkMatchingTags(mutationKey)
  })
}
